module.exports = __webpack_public_path__ + "img/naturstrom-classic-p-500.25d498df.jpeg";